// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__f-uK2","approved":"Status_approved__1vhII","rejected":"Status_rejected__31HWr","expired":"Status_expired__1tojK","label":"Status_label__Qz-vg"};